// import React, { useCallback } from 'react';
// import { useDropzone } from 'react-dropzone';

// export const PdfUploader = () => {
//   const onDrop = useCallback((acceptedFiles) => {
//     const pdfFile = acceptedFiles[0];
//     if (pdfFile && pdfFile.type === "application/pdf") {
//       console.log("PDF file uploaded:", pdfFile);
//       // You can set this file to state or send to API
//     } else {
//       alert("Please upload only PDF files.");
//     }
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: {
//       'application/pdf': ['.pdf']
//     },
//     multiple: false
//   });

//   return (
//     <div
//       {...getRootProps()}
//       style={{
//         border: '2px dashed #aaa',
//         borderRadius: '10px',
//         padding: '30px',
//         textAlign: 'center',
//         background: isDragActive ? '#f0f0f0' : '#fff',
//         cursor: 'pointer'
//       }}
//     >
//       <input {...getInputProps()} />
//       {
//         isDragActive
//           ? <p>Drop the PDF file here ...</p>
//           : <p>Drag & drop a PDF file here, or click to select file</p>
//       }
//     </div>
//   );
// };

import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import CustomButton from "../CustomButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router";
import { toast } from "react-toastify";

const PdfUploader = ({email, closeModal, setIsSent}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const { id } = useParams();

  const onDrop = useCallback((acceptedFiles) => {
    const pdfFile = acceptedFiles[0];
    if (pdfFile && pdfFile.type === "application/pdf") {
      setSelectedFile(pdfFile);
      setMessage("");
    } else {
      setMessage("Please upload only PDF files.");
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
    },
    multiple: false,
  });

  const handleUpload = async () => {
    if (!selectedFile) {
      setMessage("No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("email", email); // Make sure your API expects 'file' as key
    formData.append("pdf", selectedFile); // Make sure your API expects 'file' as key

    try {
      setUploading(true);
      setMessage("");
      const LogoutData = localStorage.getItem("login");
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/send-social-media-report/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${LogoutData}`,
          },
        }
      );
      setMessage("File uploaded successfully!");
      toast.success(response.data.data?.message)

      setIsSent(true);
      closeModal();
      
    } catch (error) {
      console.error("Upload failed:", error);
      setMessage("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {!selectedFile ? (
        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #aaa",
            borderRadius: "10px",
            padding: "30px",
            textAlign: "center",
            background: isDragActive ? "#f0f0f0" : "#fff",
            cursor: "pointer",
            marginBottom: "1rem",
          }}
        >
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop the PDF file here ...</p>
          ) : (
            <p>Drag & drop a PDF file here, or click to select file</p>
          )}
        </div>
      ) : (
        <p className="">
          <strong>Selected File:</strong> <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '20px', marginLeft:'8px' }} /> {selectedFile?.name}
        </p>
      )}

      {message && (
        <p style={{ color: message.includes("failed") ? "red" : "green" }}>
          {message}
        </p>
      )}

      {/* <button
        className="btn btn-primary mt-3"
        onClick={handleUpload}
        disabled={uploading}
      >
        {uploading ? "Uploading..." : "Upload"}
      </button> */}
      <div className="d-flex justify-content-center mt-5">
        <CustomButton
          onClick={handleUpload}
          text={uploading ? "Sending..." : "Send"}
          disabled={uploading}
          // icon={<FontAwesomeIcon icon={faPaperPlane} />}
          variant="primaryButton"
        />
      </div>
    </div>
  );
};

export default PdfUploader;
